import { css } from 'styled-components';
import { ADVENTURE_GREEN, ADVENTURE_GREEN_FOCUSED } from '../../colors';
import { appearanceNoneStyle } from '../../tokens/appearance';
import { baseHighlightStyle } from '../../tokens/highlight';
import { baseSelectionStyle } from '../../tokens/selection';
export const baseLinkStyle = css`
  ${baseSelectionStyle}
  ${baseHighlightStyle}
  ${appearanceNoneStyle}
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
  background-color: unset;
  cursor: pointer;
  transition: color 0.1s ease-out, transform 0.1s ease-out;
  color: ${ADVENTURE_GREEN};
  &:hover,
  &:active {
    color: ${ADVENTURE_GREEN_FOCUSED};
  }
`;